module.exports = __webpack_public_path__ + "mc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mc.svg
// module id = 677
// module chunks = 0